// This file was automatically generated from appchart.dialog.selectFile.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.selectFile');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.selectFile.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><p class="select-file-instructions el8LargeFontSize el8Wrap">', soy.$$escapeHtml(opt_data.instructions), '</p><div class="select-file-content feedLoading dialogContentSelectFile">');
  var reportList2801 = opt_data.reports;
  var reportListLen2801 = reportList2801.length;
  for (var reportIndex2801 = 0; reportIndex2801 < reportListLen2801; reportIndex2801++) {
    var reportData2801 = reportList2801[reportIndex2801];
    el8.template.appchart.dialog.selectFile.selectFileEntry(reportData2801, output);
  }
  output.append('</div><p class="select-file-message el8AppText el8Wrap">', soy.$$escapeHtml(opt_data.message), '</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.selectFile.selectFileEntry = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection"><label class="el8label el8CheckMark"><input type="radio" class="options" name="reports" value="', soy.$$escapeHtml(opt_data.id), '" /> ', soy.$$escapeHtml(opt_data.noteSummary), '</label></div>');
  if (!opt_sb) return output.toString();
};
